export default __webpack_public_path__ + "assets/_Chapters/_Images/background/E-Procurement/2.jpg";